// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../index';

import { LoginResponseSuccessFragmentDoc } from './loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../fragments/costumerConsultant.fragment.generated';
export const CustomerRegistrationResponseFragmentDoc = `
    fragment customerRegistrationResponse on CustomerRegistrationResponse {
  login {
    ...loginResponseSuccess
  }
}
    `;